import { render, staticRenderFns } from "./LexemeList.vue?vue&type=template&id=08426fbf&"
import script from "./LexemeList.vue?vue&type=script&lang=ts&"
export * from "./LexemeList.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports